<div
  class="flex items-center justify-center w-screen h-screen p-4 outline-none">
  <div
    class="border border-[#ebf5ff] rounded-lg overflow-hidden w-full max-w-147.5 max-h-[90vh] flex gap-4 flex-col bg-gray-50">
    <!-- Header -->
    <div class="flex items-center px-4 pt-4 gap-4">
      <div class="flex flex-1 min-w-0 gap-3 items-center">
        <div
          class="bg-primary-50 rounded-lg w-12 h-12 flex items-center justify-center shrink-0">
          <mat-icon
            svgIcon="sparkles"
            class="w-6! h-6! text-primary-700! shrink-0"></mat-icon>
        </div>
        <div class="flex flex-col gap-1 min-w-0">
          <p class="text-sm font-semibold text-gray-900 truncate">
            {{ data.headerTitle }}
          </p>
          <p class="text-xs font-medium text-gray-400">{{ generatedDate }}</p>
        </div>
      </div>
      <button
        type="button"
        (click)="close()"
        class="bg-transparent cursor-pointer shrink-0 p-1">
        <mat-icon class="w-3! h-3!" svgIcon="x-outline"></mat-icon>
        <span class="sr-only">Close</span>
      </button>
    </div>

    <!-- Content card -->
    <div class="flex-1 min-h-0 px-4 pb-0 overflow-hidden flex flex-col">
      <div
        class="bg-white border border-gray-200 rounded-lg shadow-sm p-6 flex flex-col gap-6 flex-1 min-h-0 overflow-hidden">
        <!-- Toolbar -->
        <div class="flex items-center justify-between shrink-0">
          <div class="flex items-center gap-3">
            <button
              type="button"
              (click)="copy()"
              class="flex items-center gap-2 px-3 py-2 text-xs font-medium border rounded-lg cursor-pointer transition-colors"
              [class]="
                copied()
                  ? 'border-green-600 text-green-700'
                  : 'border-primary-700 text-primary-700'
              ">
              @if (copied()) {
                <mat-icon class="w-3! h-3!" svgIcon="check"></mat-icon>
                Copied!
              } @else {
                Copy
              }
            </button>

            <button
              type="button"
              (click)="downloadPdf()"
              [disabled]="savingPdf()"
              class="flex items-center gap-2 px-3 py-2 text-xs font-medium border border-primary-700 text-primary-700 rounded-lg transition-colors"
              [class]="
                savingPdf() ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
              ">
              @if (savingPdf()) {
                <icaredx-spinner size="xs" color="secondary" />
              } @else if (savedPdf()) {
                <mat-icon class="w-3! h-3!" svgIcon="check"></mat-icon>
              } @else {
                <mat-icon
                  class="w-3! h-3!"
                  svgIcon="arrow-down-to-bracket"></mat-icon>
              }
              Save as PDF
            </button>
          </div>

          <div class="flex items-center gap-3">
            <button
              type="button"
              (click)="increaseFontSize()"
              [disabled]="fontSizeIndex() === fontSizeMaxIndex"
              title="Increase font size"
              class="w-8.5 h-8.5 px-3 py-2 flex items-center justify-center border border-primary-700 text-primary-700 rounded-lg transition-colors"
              [class]="
                fontSizeIndex() === fontSizeMaxIndex
                  ? 'opacity-40 cursor-not-allowed'
                  : 'cursor-pointer hover:bg-primary-50'
              ">
              <span class="font-serif text-sm font-bold leading-none"
                >A<sup class="text-[9px] not-italic">+</sup></span
              >
            </button>
            <button
              type="button"
              (click)="decreaseFontSize()"
              [disabled]="fontSizeIndex() === 0"
              title="Decrease font size"
              class="w-8.5 h-8.5 px-3 py-2 flex items-center justify-center border border-primary-700 text-primary-700 rounded-lg transition-colors"
              [class]="
                fontSizeIndex() === 0
                  ? 'opacity-40 cursor-not-allowed'
                  : 'cursor-pointer hover:bg-primary-50'
              ">
              <span class="font-serif text-sm font-bold leading-none"
                >A<sup class="text-[9px] not-italic">-</sup></span
              >
            </button>
          </div>
        </div>

        <!-- Scrollable content -->
        <div class="flex-1 min-h-0 overflow-y-auto flex flex-col gap-4">
          <div
            class="ql-editor p-0! h-auto! overflow-visible! leading-relaxed text-gray-500 font-normal"
            [class]="fontSizeClass()"
            [innerHTML]="displayedHtml()"></div>

          <div class="h-px bg-[#e4e4e4] shrink-0"></div>

          <div class="flex flex-col gap-2 shrink-0">
            @if (data.question) {
              <p class="text-[13px] text-gray-900 leading-normal">
                <span class="font-medium">Based on: </span
                ><span class="font-normal text-sm">{{ data.question }}</span>
              </p>
            }
            <p
              class="text-[13px] font-light text-gray-900 tracking-[0.39px] leading-normal">
              {{ data.result.disclaimer }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end pb-5 pt-1 px-5">
      <button
        type="button"
        (click)="close()"
        class="bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 cursor-pointer transition-colors">
        Close
      </button>
    </div>
  </div>
</div>
